import { Component, ElementRef, NgZone, ChangeDetectorRef, ViewEncapsulation, ViewChild, Input } from '@angular/core';
import { AppService } from '@suite/app.service';
import { TimeoutQueue } from '@common/services/timeout-queue';

import { GlobalTablesService } from "@common/services/global-tables-service";
import { EnpsControl } from '../enps-control/enps-control';
import { MatSelectionListChange } from '@angular/material/list';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatChipInputEvent } from '@angular/material/chips';
import { Staff } from '@common/data-models/service/staff';
import { LanguageSettings } from '../../services/language-settings';
import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { optionContainsTerm } from '../../utils/util';

@Component({
    selector: 'staff-id-list',
    templateUrl: './staff-id-list.html',
    styleUrls: ['./staff-id-list.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'st-staff-id-list'
    }
})

export class StaffIDList extends EnpsControl<string[]> {

    get allUsers(): Staff[] {
        return Object.values(this.globalTablesService.Staff);
    }

    get searchLabel(): string {
        return `${this.languageSettings.PSTWebSearchLabel + "..."}`;
    }

    get extraStaffCount(): number {
        return this.value.length - 4;
    }

    get shouldShowExtraStaff(): boolean {
        return this.value.length > 5;
    }


    public getItemInitials(item: any) {
        return this.allUsers.find(option => (option.UserID.toLowerCase().includes(item?.toLowerCase())))?.Initials;
    }

    staffFilter = new FormControl('');
    filteredOptions: Observable<string[]>;
    toolTipData: Array<string> = [];
    isListOpen: boolean = false;
    @ViewChild(CdkConnectedOverlay) overlay: CdkConnectedOverlay;
    @Input() shouldShowAddButton: boolean = true;

    constructor(
        public appService: AppService,
        ngZone: NgZone,
        changeDetectorRef: ChangeDetectorRef,
        timeoutQueue: TimeoutQueue,
        globalTablesService: GlobalTablesService,
        protected _elementRef: ElementRef,
        public languageSettings: LanguageSettings,
    ) {
        super(appService, ngZone, changeDetectorRef, timeoutQueue, globalTablesService, _elementRef);
    }

    ngOnInit() {
        this.filteredOptions = this.staffFilter.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '')),
        );
    }

    public displayNameByKey(key: string): string {
        return (this.globalTablesService.Staff && this.globalTablesService.Staff[key]) ? this.globalTablesService.Staff[key].GivenName + " " + this.globalTablesService.Staff[key].Surname : "";
    }

    internalValueChanged(event: MatSelectionListChange) {
        this.value = event.source.selectedOptions.selected.map((item) => item.value);
    }

    valueChanged() {
        if (this.isValueChanged) {
            this.isValueChanged = false;
            this.changed.emit(this.value);
        }
        this.staffFilter.setValue('');
    }

    getName(userId: string) {
        let user = this.globalTablesService?.Staff[userId];
        return `${user?.GivenName} ${user?.Surname}`;
    }

    getUserInfo(userId: string) {
        let user = this.globalTablesService?.Staff[userId];
        return `${user.Email ? user.Email : ''} ${user.Title ? user.Title : ''} ${user.Phone ? user.Phone : ''}`;
    }

    get tooltipUsers(): Staff[] {
        if(this.toolTipData?.length > 5) {
            let users = this.value?.slice(4)
            return this.allUsers.filter(option => (users.includes(option.UserID))).map((item) => item);
        } else {
            return this.allUsers.filter(option => (this.toolTipData.includes(option.UserID))).map((item) => item);
        }
    }

    private _filter(value: string): string[] {
        return this.allUsers.filter(option => (optionContainsTerm(option.UserID, value) || optionContainsTerm(option.DisplayName, value))).map((item) => item.UserID);
    }

    add(event: MatChipInputEvent): void {
        const value = (event.value || '').trim().toLowerCase();
        const data = this.allUsers.find(option => {
            if(value) {
                let filteredUser = (optionContainsTerm(option.UserID, value) || optionContainsTerm(option.DisplayName, value))
                return filteredUser;
            }
        })
        if (data) {
            if(!this.value) this.value = [];
            this.value.push(data.UserID);
        }

        event.chipInput!.clear();
        this.isValueChanged = true;

        this.staffFilter.setValue('');
    }

    remove(fruit: string): void {
        const index = this.value.indexOf(fruit);

        if (index >= 0) {
            this.value.splice(index, 1);
        }
        this.isValueChanged = true;
    }

    selected(event: MatSelectionListChange): void {
        const selectedUser = this.value.find(option => option === event.options[0].value)
        if (selectedUser) return;
        if(!this.value) this.value = [];
        this.value.push(event.options[0].value);
        this.searchBox.nativeElement.value = '';
        this.staffFilter.setValue('');
        this.isValueChanged = true;
    }

    showStaffTooltip(value) {
        this.toolTipData = [...value]
        this.isListOpen = true;
    }

    onMouseOut(event: MouseEvent) {
        if (!(event.relatedTarget as HTMLElement)?.classList?.contains('st-staff-id-list-tooltip-content')) {
            this.isListOpen = false;
        }
    }

    panelAttached() {
        const overlayElement = this.overlay?.overlayRef?.overlayElement;
        if (overlayElement) {
            overlayElement.addEventListener("mouseleave", (e) => {
                this.isListOpen = false;
            });
        }
    }
}

